<template>
    <div class="chart-container">
        <div class="label">
            <span
                v-if="model.zoneValue != null"
                class="zone"
            >{{ model.formatWithUnits(model.zoneValue) }} in Zone</span>
            <span
                v-if="model.zoneValue != null"
                class="spacer"
            > | </span>
            <span class="ab">{{ model.formatWithUnits(model.abValue) }} in AB</span>
        </div>
        <div class="label">
            {{ model.label }}
        </div>
        <div class="data-unavailable-label">
            Data Unavailable for {{ model.valueLabel }}
        </div>

        <info-tooltip
            :definition="model.definition"
            :link-to-health="model.linkToHealth"
            :data-source="model.dataSource"
        />
    </div>
</template>

<script>
import InfoTooltip from '@/components/InfoTooltip.vue';

import MetricChartModel from '@/model/MetricChartModel';

export default {
    components: {
        InfoTooltip
    },
    props: {
        model: {
            type: MetricChartModel,
            required: true
        }
    }
};
</script>

<style src="./common.container.css" scoped></style>
<style lang="postcss" scoped>
div.label {
    @apply leading-snug;
}

.data-unavailable-label {
    @apply text-2xs leading-loose;
}
span.spacer {
    @apply text-base px-1 font-normal;
}

.label span.ab {
    @apply text-neutral-text;
}
</style>
